import { render, staticRenderFns } from "./addShiftsComponent.vue?vue&type=template&id=c6b70b0c&"
import script from "./addShiftsComponent.vue?vue&type=script&lang=js&"
export * from "./addShiftsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports